import $ from 'jquery';
export default class Toggle {
  constructor(el) {
    this.el = el;

    el.addEventListener('click', this.handleClicks);
  }

  handleClicks(event) {
    event.preventDefault();
    if (event.target.dataset.class) {
      const targetClass = event.target.dataset.class;
      const target = document.querySelector(`.${targetClass}`);

      if ($(event.target).hasClass('is-active')) {
        target.classList.toggle('is-active');
        event.target.classList.toggle('is-active');
      } else {
        target.classList.toggle('is-active');
        event.target.classList.toggle('is-active');
      }
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/modules/Toggle.js